import { styled } from '@mui/material/styles';
import Typography, { TypographyProps } from '@mui/material/Typography';

import StampMask from 'assets/stamp-mask.png';
import { CSSProperties } from 'react';

interface PropTypes {
    color?: TypographyProps['color'];
    borderColor?: TypographyProps['color'];
    transform?: CSSProperties['transform'];
    children: React.ReactNode;
}

const StatusText = styled(Typography)<TypographyProps>(({ theme }) => ({
    fontSize: '2rem',
    fontWeight: 700,
    lineHeight: 1,
    color: theme.palette.primary.main,
    borderWidth: '0.25rem',
    borderRadius: '1rem',
    borderStyle: 'solid',
    borderColor: theme.palette.primary.main,
    padding: '0.25rem',
    textTransform: 'uppercase',
    fontFamily: 'Courier',
    WebkitMaskImage: `url(${StampMask})`,
    WebkitMaskSize: '944px 604px',
}));

export default function RubberStamp({
    color = 'primary.main',
    borderColor,
    transform = 'rotate(0deg)',
    children
}: PropTypes) {
    return (
        <StatusText align="center" sx={{
            color: color,
            borderColor: borderColor ?? color,
            transform: transform
        }}>
            {children}
        </StatusText>
    );
}